import { SET_CRITERIAS_ASYNC, SET_TAB_TRIGGER, GET_PROFILE_STORIES_ASYNC, SET_HOME_LOADING, REMOVE_STORY_FROM_LIST } from './action-types';

const initialState = {
  criterias: {
    search: '',
    prompts: [],
    collaborators: [],
    tab: 0,
  },
  stories: {
    draftStories: [],
    publishedStories: [],
    collaboratorStories: [],
    purchasedStories:[],
  },
  storiesResult: [],
  homeLoading: true,
};

const intermitence = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case SET_TAB_TRIGGER:
      return { ...state, criterias: payload };
    case SET_CRITERIAS_ASYNC:
      return { ...state, criterias: { ...payload.criterias }, storiesResult: [...payload.result] };
    case GET_PROFILE_STORIES_ASYNC:
      return { ...state, stories: payload };
    case SET_HOME_LOADING:
      return { ...state, homeLoading: payload };

    case REMOVE_STORY_FROM_LIST:
      return {
        ...state,
        stories: {
          draftStories: state.stories.draftStories.filter((s: any) => s.id !== payload),
          publishedStories: state.stories.publishedStories.filter((s: any) => s.id !== payload),
          collaboratorStories: state.stories.collaboratorStories.filter((s: any) => s.id !== payload),
          purchasedStories: state.stories.purchasedStories.filter((s: any) => s.id !== payload),
        },
        storiesResult: state.storiesResult.filter((s: any) => s.id !== payload),
      };

    default:
      return state;
  }
};

export default intermitence;
